/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Caption_Style_Pop_OnInputs */

const en_input_caption_style_pop_on = /** @type {(inputs: Input_Caption_Style_Pop_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pop-On`)
};

const fr_input_caption_style_pop_on = /** @type {(inputs: Input_Caption_Style_Pop_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pop-On`)
};

const de_input_caption_style_pop_on = /** @type {(inputs: Input_Caption_Style_Pop_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pop-On`)
};

const it_input_caption_style_pop_on = /** @type {(inputs: Input_Caption_Style_Pop_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pop-On`)
};

const ru_input_caption_style_pop_on = /** @type {(inputs: Input_Caption_Style_Pop_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pop-On`)
};

const es_input_caption_style_pop_on = /** @type {(inputs: Input_Caption_Style_Pop_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pop-On`)
};

const zh_cn2_input_caption_style_pop_on = /** @type {(inputs: Input_Caption_Style_Pop_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`弹出式`)
};

const ja_input_caption_style_pop_on = /** @type {(inputs: Input_Caption_Style_Pop_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ポップオン`)
};

const hi_input_caption_style_pop_on = /** @type {(inputs: Input_Caption_Style_Pop_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पर पॉप`)
};

const pt_pt2_input_caption_style_pop_on = /** @type {(inputs: Input_Caption_Style_Pop_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pop-On`)
};

/**
* | output |
* | --- |
* | "Pop-On" |
*
* @param {Input_Caption_Style_Pop_OnInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_caption_style_pop_on = /** @type {((inputs?: Input_Caption_Style_Pop_OnInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Caption_Style_Pop_OnInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_caption_style_pop_on(inputs)
	if (locale === "de") return de_input_caption_style_pop_on(inputs)
	if (locale === "it") return it_input_caption_style_pop_on(inputs)
	if (locale === "ru") return ru_input_caption_style_pop_on(inputs)
	if (locale === "es") return es_input_caption_style_pop_on(inputs)
	if (locale === "zh-CN") return zh_cn2_input_caption_style_pop_on(inputs)
	if (locale === "ja") return ja_input_caption_style_pop_on(inputs)
	if (locale === "hi") return hi_input_caption_style_pop_on(inputs)
	if (locale === "pt-PT") return pt_pt2_input_caption_style_pop_on(inputs)
	return en_input_caption_style_pop_on(inputs)
});